import { combineReducers } from 'redux';
import app from './app';
import notification from "./notification";
import lookups from "./lookups";
import appAuth from "./app_auth";

export const appReducer = combineReducers({ app, notification, lookups, appAuth });
